import { Stage } from "./client/Client";


class Store {
    public store: Stage[]
}



export default Store;